const Asset = () => import(/* webpackChunkName: "Asset" */ '../Asset');
const AssetIndex = () => import(/* webpackChunkName: "Asset" */ '../index');

export default {
  path: 'ativo',
  name: 'asset',
  component: AssetIndex,
  meta: {
    breadcrumb: {
      name: 'page-name.asset',
      noTitle: true,
    },
  },
  redirect: {
    name: 'monitoring',
  },
  children: [
    {
      path: ':assetId',
      name: 'asset.asset-id',
      component: Asset,
    },
  ],
};
